import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';

import { PageTitle } from 'components/common/Elements/Elements';

import SettingsRoutes from './parts/SettingsRoutes/SettingsRoutes';
import SettingsLinks from './parts/SettingsLinks/SettingsLinks';

const Settings = () => {
  const { t } = useTranslation('settings');

  let { url } = useRouteMatch();
  let newUrl = url.split('/');
  newUrl.pop();
  newUrl = newUrl.join('/');

  return (
    <>
      <PageTitle title={t('settings:TITLE_HEADING_SETTINGS')} />
      <SettingsLinks newUrl={newUrl} />
      <SettingsRoutes newUrl={newUrl} />
    </>
  );
};

export default Settings;
